import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import { useTransactionHistory } from "../hooks/use-transaction-history";
import { DataTable } from "./data-table";
import { transactionHistoryColumns } from "./transaction-history-columns";

const coreRowModel = getCoreRowModel();

export function TransactionHistoryTable() {
	const { t } = useTranslate();
	const { rows, isLoading, isError, refetch } = useTransactionHistory();

	const table = useReactTable({
		data: rows,
		columns: transactionHistoryColumns,
		getCoreRowModel: coreRowModel,
	});

	return (
		<div className="min-w-0">
			<h2 className="mb-4 text-body2-bold text-foreground">
				{t("portfolio.transaction-history")}
			</h2>
			<DataTable
				table={table}
				emptyMessage={t("portfolio.no-transactions")}
				isLoading={isLoading}
				loadingMessage={t("state.loading-wallet")}
				heightClassName="h-80"
				contentClassName="min-w-[660px]"
				isError={isError}
				onRetry={refetch}
			/>
		</div>
	);
}
